export default {
  getSharedEnv: _ref => {
    var {
      payload
    } = _ref;
    return payload;
  },
  tracking: _ref2 => {
    var {
      payload
    } = _ref2;
    return payload.tracking;
  },
  oauth: _ref3 => {
    var {
      payload
    } = _ref3;
    return payload.oauth;
  }
};